var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',_vm._l((_vm.users),function(user){return _c('SharedUserItem',{key:user.id,staticClass:"share-list-item",attrs:{"user":user,"workflow":_vm.workflow,"userShareData":_vm.getUserShareData(user),"hideVisibilityStatus":_vm.hideVisibilityStatus}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }